/**
 * Template: Product
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */
import { load } from '@shopify/theme-sections';
import countDown from '~/components/count-down';
import ProductForm from '~/components/product-form';
import ProductGallery from '~/components/product-gallery';
import SizeGuide from '../components/size-guide';
import cssClasses from '~/helpers/cssClasses';
import '~/sections/recommended-products';
import { on } from '~/helpers/utils';
import breakpoints from '~/helpers/breakpoints';
document.addEventListener('DOMContentLoaded', () => {
  /**
   * DOM selectors.
   */
  const selectors = {
    countDown: '[js-count-down="container"]',
    formDetailWrapper: '[js-product-template="formDetailWrapper"]',
    orderGalleryForm: '[js-product-template="orderGalleryForm"]',
    productAside: '[js-product-gallery="productAside"]',
    siteHeaderContainer: '[js-site-header="container"]',
    sizeGuide: '[js-template-product="sizeGuide"]',
    sizeGuideContainer: '[js-size-guide="container"]',
    templateProductContainer: '[js-template-product="container"]'
  };
  /**
   * DOM node selectors.
   */

  const nodeSelectors = {
    countDown: document.querySelector(selectors.countDown),
    formDetailWrapper: document.querySelector(selectors.formDetailWrapper),
    orderGalleryForm: document.querySelector(selectors.orderGalleryForm),
    productAside: document.querySelector(selectors.productAside),
    siteHeaderContainer: document.querySelector(selectors.siteHeaderContainer),
    sizeGuide: document.querySelector(selectors.sizeGuide),
    sizeGuideContainer: document.querySelector(selectors.sizeGuideContainer),
    templateProductContainer: document.querySelector(selectors.templateProductContainer)
  };
  load('recommended-products');
  ProductForm({
    container: 'container',
    enableSwatches: true
  }).init();
  ProductGallery().init();
  SizeGuide().init();
  setEventListener();
  adjustProductNavStyle();

  if (nodeSelectors.countDown) {
    countDown().init(nodeSelectors.countDown);
  }
  /**
   * Initial styling set up for pdp body.
   */


  function adjustProductNavStyle() {
    const navHeight = nodeSelectors.siteHeaderContainer.offsetHeight;
    nodeSelectors.templateProductContainer.style.marginTop = "".concat(navHeight, "px");

    if (!window.matchMedia("(min-width: ".concat(breakpoints.large, ")")).matches) {
      return;
    }

    nodeSelectors.formDetailWrapper.style.height = "".concat(nodeSelectors.orderGalleryForm.offsetHeight, "px");
    nodeSelectors.productAside.classList.add('fixed-height');
  }
  /**
   * Set event listeners.
   */


  function setEventListener() {
    if (!nodeSelectors.sizeGuide) {
      return;
    }

    on('click', nodeSelectors.sizeGuide, event => handleSizeGuide(event));
  }
  /**
   * Handle opening size guide modal.
   */


  function handleSizeGuide(event) {
    event.preventDefault();

    if (!nodeSelectors.sizeGuideContainer) {
      return;
    }

    nodeSelectors.sizeGuideContainer.classList.add(cssClasses.active);
  }
});